class Observer {
  /**
   * @type {{}}
   * @private
   */
  _listeners = {};

  /**
   * @param key {string} - subscription key
   * @param [data] {any} - data to deliver to subscribers
   */
  trigger = (key, data) => {
    if (this._listeners[key]) {
      Object.values(this._listeners[key]).forEach((cb) => cb(data));
    }
  };

  /**
   * @param key {string} - subscription key
   * @param cb {function} - callback
   * @returns {(function(): void)} - unsubscribe function
   */
  subscribe = (key, cb) => {
    const id = this._id;
    if (!this._listeners[key]) {
      this._listeners[key] = {};
    }
    this._listeners[key][id] = cb;
    return () => {
      delete this._listeners[key][id];
    };
  };

  /**
   * @param keys {Object.<string, function>}
   * @param keyPrefix {string}
   * @returns {(function(): void)} - unsubscribe function
   */
  subscribeMany = (keys, keyPrefix = "") => {
    const id = this._id;
    const _keys = Object.keys(keys);
    _keys.forEach((key) => {
      const cb = keys[key];
      const _key = keyPrefix + key;
      if (!this._listeners[_key]) {
        this._listeners[_key] = {};
      }
      this._listeners[_key][id] = cb;
    });

    return () => {
      _keys.forEach((key) => {
        const _key = keyPrefix + key;
        delete this._listeners[_key][id];
      });
    };
  };

  /**
   * @returns {string}
   * @private
   */
  get _id() {
    return Date.now() + "_" + Math.random();
  }
}

export const observer = new Observer();
